// extracted by mini-css-extract-plugin
module.exports = {"button":"UploadButton_button__nHupj","text":"UploadButton_text__ilfwS","disabled-button":"UploadButton_disabled-button__yylq1","disabled-text":"UploadButton_disabled-text__2iwLp"};